import { Contract } from '@ekt-group/general-purpose-api-interfaces';
import { FileCheck03 } from '@untitled-ui/icons-react';
import { Skeleton } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import CustomBadge from '@/components/ui/Badge';
import Button from '@/components/ui/Button';
import { useGetContracts } from '@/features/contracts/api/use-get-contracts';
import { useUserInfoStore } from '@/store';

const ContractsActionCard = () => {
  const { t } = useTranslation('desktopPage');
  const { selectedAccount } = useUserInfoStore();

  const contractsQuery = useGetContracts({
    params: {
      disablePagination: true,
      ownerCodes: [selectedAccount?.code],
    },
    queryConfig: {
      enabled: !!selectedAccount?.code,
    },
  });
  const contracts = (contractsQuery.data as Contract[])?.filter((contract) => dayjs(contract.endDate).isAfter(dayjs()));

  const unsignedContracts = contracts?.filter((contract) => contract.signedStatus === 0);
  const upcomingContracts = contracts?.filter((contract) => contract.startDate && dayjs(contract.startDate).isAfter(dayjs()));

  const navigate = useNavigate();

  if (contractsQuery.isLoading || contractsQuery.isFetching) {
    return (
      <div className="bg-white h-[218px] sm:h-auto sm:flex-1 flex flex-col justify-between rounded-[32px] p-5">
        <Skeleton active paragraph={{ rows: 3 }} />
      </div>
    );
  }

  return (
    <div className="bg-white h-[218px] sm:h-auto sm:flex-1 flex flex-col justify-between rounded-[32px] p-5">
      <div className="flex flex-col gap-2">
        <div className="flex mb-2 justify-between items-center">
          <span className="text-[20px] text-[#595959] font-bold">{t('contracts', { ns: 'header' })}</span>
          <FileCheck03 className="w-6 h-6 text-[#9C8B7E]" />
        </div>
        <div className="flex flex-col items-start space-y-2 mb-4">
          {Boolean(upcomingContracts?.length) && (
            <CustomBadge variant="warning">
              {t('upcoming')}: {upcomingContracts?.length}
            </CustomBadge>
          )}

          {unsignedContracts?.length ? (
            <CustomBadge variant="danger">
              {t('unsigned')}: {unsignedContracts?.length}
            </CustomBadge>
          ) : (
            <CustomBadge variant="success">{t('allSigned')}</CustomBadge>
          )}
        </div>
      </div>
      {unsignedContracts?.length ? (
        <Button onClick={() => navigate(`/contracts/${unsignedContracts[0].id}/sign`)}>
          {t('sign')} L{unsignedContracts[0].contractNumber}
        </Button>
      ) : (
        <Button variant="primaryLight" onClick={() => navigate('/contracts')}>
          {t('viewAll')}
        </Button>
      )}
    </div>
  );
};

export default ContractsActionCard;
